/**
 * Conponent for a textarea
 */

import {Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, SimpleChange} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {TranslateService} from "@ngx-translate/core";
import {Donation} from "../donation/donation";
import {OptionService} from "../option/option.service";

@Component({
    selector: 'input-remarks',
    templateUrl: './input.remarks.component.html'
})
export class InputRemarksComponent implements OnInit, OnChanges{
    /**
     * Text for the label
     */
    @Input() labelKey: string = 'donation.remarks.label';

    /**
     * Text in case of errors
     */
    @Input() errorKey: string; 'donation.remarks.error';

    /**
     * initial value for the field
     */
    @Input() value: string;

    /**
     * The current donation
     */
    @Input() donation: Donation;

    /**
     * extra class for the field wrapper
     */
    @Input() wrapperClass: string;

    /**
     * form object for the validation
     */
    @Input() form: FormGroup;

    /**
     * Number of rows for the input
     */
    @Input() rows: number = 1;

    /**
     * Label should be always visible or not
     */
    @Input() showLabel: boolean = true;

    /**
     * maximal number of the input in this field.
     */
    @Input() maxLength: number = 500;

    /**
     * eventemitter if the value changes
     * @type {EventEmitter<any>}
     */
    @Output() modelChange: EventEmitter<any> = new EventEmitter();

    /**
     * Does the field has a value or not
     * @type {boolean}
     */
    hasValue: boolean = false;

    /**
     * can be set manually to set a special placeholder that is different from the label
     *
     * @type {String}
     */
    placeholder: string = null;

    /**
     * name for the field
     */
    name: string = 'remarks';

    /**
     * toggle for showing/hiding this element
     */
    showElement: boolean = false;

    /**
     * List of triggerwords for the remarks field
     */
    infotextTriggerWords: string[] = [];

    /**
     * constructor
     * @param {OptionService} optionService
     * @param {TranslateService} translate
     */
    public constructor(private optionService: OptionService, private translate: TranslateService) {}

    /**
     * called if the component is initialized
     */
    public ngOnInit(): void {
        // decide to show/hide this element
        this.showElement = this.optionService.getOption('has_remarks') === true;

        // add formelement to form
        this.form.addControl('remarks', new FormControl());

        // check if we have a value here
        if(this.value && this.value.length > 0) {
            this.hasValue = true;
        }

        // get the triggerwords for the hinttext on the remark field
        this.translate.get('donation.remarks.trigger').subscribe(data => {
            if(data) {
                // split the triggerwords on the comma and transfer them to lowercase.
                this.infotextTriggerWords = data.split(",").map(triggerWord => triggerWord.trim().toLowerCase());
            }
        });
    }

    /**
     * is triggered every time the model changes (from outside) and updates the css classes
     *
     * @param {SimpleChanges} changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if(changes.model && changes.model.currentValue) {
            this.hasValue = (changes.model.currentValue.length > 0);
        }
    }

    /**
     * Returns if the field is valid or not
     * @returns {boolean}
     */
    elementValid(): boolean {
        return this.form.controls[this.name].disabled ||
            this.form.controls[this.name].touched == false ||
            this.form.controls[this.name].valid == true;
    }

    /**
     * Function to update the model and inform the parent Component about it.
     * We can not use databinding here because it will not work together with
     * @param event
     */
    updateModel(event:any) {
        this.modelChange.emit(this.donation.remarks);
        this.hasValue = (this.donation.remarks.length > 0);
    }
}
